import React, { useEffect, useState } from "react";
import Section_title from "../../../common-components/section-title/Section_title";
import Form from "react-bootstrap/Form";
import { Link, useSearchParams } from "react-router-dom";
import Select from "react-select";
import { IndexUse } from "./IndexUse";
import { IDS } from "../../../../utils/IDS";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import classNames from "classnames";
import Pagination_Holder from "../../../common-components/Pagination_Holder/Pagination_Holder";
import Table_search from "../../../common-components/table-search/Table_search";
import Delete_Modal from "../../../common-components/common_Modal/Delete_Modal/Delete_Modal";
import Delete_Confirm_Modal from "../../../common-components/common_Modal/Delete_Confirm_Modal/Delete_Confirm_Modal";
import { formatDate } from "../../../../utils/common";
import {
  getAllCities,
  getAllCitiesWithoutType,
  getAllVehicleCategory,
  getAllVehicleCatWithoutType,
} from "../../../../features/admin/common/Slice";
import { DOWNLOAD_EXCEL } from "../../../../utils/Methods";
const Country = () => {
  const dispatch = useDispatch();

  const Permission = useSelector((state) => state.auth?.admin_info);

  const {
    recharge,
    name,
    setName,
    status,
    setStatus,
    fetch,
    modalMessage,
    modalShow,
    setModalShow,
    setSearchDistrict,
    searchDistrict,
    from,
    setFrom,
    to,
    setTo,
    vehicleCategory,
    setVehicleCategory,
    searchVehicleCategory,
    setSearchVehicleCategory,
  } = IndexUse();

  const handlePageChange = async (page) => {
    await fetch(page);
  };

  const allCitiesData = useSelector(
    (state) => state.common?.all_cities_without_type,
  );

  const allVehicleCategoryData = useSelector(
    (state) => state.common.all_vehicle_category_without_type,
  );

  console.log(allVehicleCategoryData, "allVehicleCategoryData");

  useEffect(() => {
    dispatch(getAllCitiesWithoutType());
    dispatch(getAllVehicleCatWithoutType());
  }, [dispatch]);

  const HandleDownload = async () => {
    try {
      await DOWNLOAD_EXCEL(
        `/admin/recharge-management/user-recharge/download?name=${name ||
          ""}&district_id=${searchDistrict?.value || ""}&status=${status ||
          ""}&from=${from || ""}&to=${to || ""}`,
        {},
        "User Recharge List",
      );
    } catch (error) {
      console.error("Error:", error);
    }
  };
  return (
    <section className="content_body section_box">
      <div className="top_title_sec">
        <div className="forms_section">
          <div className="row align-items-end">
            <div className="col-md-12">
              <Section_title title="Recharge History" alltotal="" />
            </div>
            <div className="col-md-4 mb-3 form-group">
              <label className="form-label">Filter by Driver Name</label>
              <Form.Control
                type="text"
                placeholder="Enter Driver Name"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </div>
            <div className="col-md-4 mb-3 form-group">
              <label className="form-label">Filter by District</label>
              <Select
                name="district_id"
                value={searchDistrict}
                options={allCitiesData}
                placeholder={"Search District"}
                onInputChange={() => {
                  dispatch(getAllCitiesWithoutType());
                }}
                onChange={(val) => {
                  setSearchDistrict(val);
                  fetch();
                }}
              />
            </div>
            <div className="col-md-4 mb-3 form-group">
              <label className="form-label">Filter by Vehicle Category</label>
              <Select
                name="district_id"
                value={vehicleCategory}
                options={allVehicleCategoryData}
                placeholder={"Search Vehicle Category"}
                onInputChange={() => {
                  dispatch(getAllVehicleCategory());
                }}
                onChange={(val) => {
                  setVehicleCategory(val);
                  fetch();
                }}
              />
            </div>
            <div className="col-md-4 mb-3 form-group">
              <label className="form-label">Filter by From Date</label>
              <Form.Control
                type="date"
                placeholder="Enter From"
                value={from}
                onChange={(e) => {
                  setFrom(e.target.value);
                  handlePageChange(1);
                  setTo("");
                }}
              />
            </div>
            <div className="col-md-4 mb-3 form-group">
              <label className="form-label">Filter by To Date</label>
              <Form.Control
                type="date"
                placeholder="Enter To"
                value={to}
                onChange={(e) => {
                  setTo(e.target.value);
                  handlePageChange(1);
                }}
                min={from}
              />
            </div>
            <div className="col-md-4 mb-3" style={{ width: "fit-content" }}>
              <button
                className="btn btn-danger "
                onClick={() => {
                  setName("");
                  setStatus("");
                  setSearchDistrict("");
                  setFrom("");
                  setTo("");
                  setVehicleCategory("");
                }}
              >
                Reset
              </button>
            </div>
            <div className="mb-3">
              {/* <CButton name="Reset" variant="danger" action={handleReset} /> */}
              {/* <CButton name="Add" variant="success" action={() => setAdd(true)} /> */}
              <button className="btn btn-success " onClick={HandleDownload}>
                Download Excel
              </button>
            </div>{" "}
          </div>
        </div>
      </div>

      <div className="table_section theme_bg">
        <div className="table-responsive">
          <table className="table table-bordered table-striped">
            <thead>
              <tr>
                <th>S. no.</th>
                <th>District</th>
                <th>Driver Name</th>
                <th>Driver Number</th>
                <th>Price</th>
                <th>Vehicle Category</th>
                <th>Discount Percent</th>
                <th>Tax Percent</th>
                <th>Expiry Date</th>
                <th>Status</th>
                <th>Created At</th>
              </tr>
            </thead>
            <tbody>
              {recharge?.data?.data?.length > 0 ? (
                recharge?.data.data?.map((val, index) => (
                  <tr key={index}>
                    <td>
                      {(recharge?.data?.current_page - 1) *
                        recharge?.data?.per_page +
                        index +
                        1}
                    </td>
                    <td>{val?.Recharge?.City?.name || "-"}</td>
                    <td>{val?.User?.first_name}</td>
                    <td>{val?.User?.contact_no}</td>
                    <td>₹ {val?.price}</td>
                    <td>
                      {val?.Recharge?.Vehicle_Category?.name}{" "}
                      {val?.Recharge?.Vehicle_Category?.type || "-"}
                    </td>
                    <td>{`${val?.discount_percent}%` || "-"}</td>
                    <td>{`${val?.tax_percent}%` || "-"}</td>
                    <td>
                      {val?.expiry_date
                        ? formatDate(val?.expiry_date) || "-"
                        : "-"}
                    </td>
                    <td
                      className={val?.status ? "text-success" : "text-danger"}
                    >
                      {val?.status ? "Active" : "Inactive"}
                    </td>
                    <td>
                      {val?.createdAt
                        ? new Date(val.createdAt).toLocaleDateString("en-GB")
                        : "-"}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4" className="text-center">
                    No Data
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      <Pagination_Holder
        onPageChange={recharge?.data?.current_page}
        totalPages={recharge?.data?.total_pages}
        handlePageChange={handlePageChange}
      />
    </section>
  );
};

export default Country;
